import { useState } from 'react';
import { FileText, Loader2 } from 'lucide-react';
import type { PortalStatementEntry } from '../../types';
import { statementChangeOrderLines, statementScheduleRows, type StatementChangeOrderInput, type StatementScheduleFold, type StatementScheduleStatus } from '../../utils/portalStatement';
import { downloadPortalStatementPdf } from '../../utils/portalStatementPdf';
import './PortalStatementButton.css';

export default function PortalStatementButton(props: {
  projectName: string;
  clientCompany?: string;
  clientName?: string;
  projectNumber?: string | null;
  originalContract: number;
  changeOrderTotal: number;
  currentContractValue: number;
  changeOrders?: StatementChangeOrderInput[];
  schedule: Array<{
    id: string;
    label: string;
    detail: string;
    amount: number;
    kind?: 'installment' | 'change_order';
    baseAmount?: number;
    folded?: StatementScheduleFold[];
  }>;
  statuses?: Record<string, StatementScheduleStatus | undefined>;
  activity?: PortalStatementEntry[];
}) {
  const [downloading, setDownloading] = useState(false);

  const download = async () => {
    if (downloading) return;
    setDownloading(true);
    try {
      await downloadPortalStatementPdf({
        projectName: props.projectName,
        clientCompany: props.clientCompany,
        clientName: props.clientName,
        projectNumber: props.projectNumber,
        originalContract: props.originalContract,
        changeOrderTotal: props.changeOrderTotal,
        currentContractValue: props.currentContractValue,
        changeOrders: statementChangeOrderLines(props.changeOrders),
        schedule: statementScheduleRows({ rows: props.schedule, statuses: props.statuses }),
        activity: props.activity || [],
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button type="button" className="portal-statement-open" onClick={() => { void download(); }} disabled={downloading}>
      {downloading ? <Loader2 size={14} /> : <FileText size={14} />}
      {downloading ? 'Preparing…' : 'Statement'}
    </button>
  );
}
